module.exports = __webpack_public_path__ + "static/images/left-arrow.1473f803af9f12adafc59036968c0c24.svg";